import React from 'react';
import { ButtonColors, PrimaryButton } from 'src/shared/design-system/Buttons';
import { Cart as CartIcon } from 'src/shared/design-system/Icon';
import styled from 'styled-components';
import { BorderRadius, Colors, FontSize, Spacing } from 'web-common/src/shared/styles';

interface CartButtonProps {
  displayNum: number;
}

const StyledCartButton = styled(PrimaryButton)`
  border-radius: ${BorderRadius.S};
  font-size: ${FontSize.XS};
  height: 32px;
  padding: 0 ${Spacing.HALF};
`;

const ShefCartsNumber = styled.div`
  align-items: center;
  background-color: ${Colors.WHITE};
  border-radius: 100%;
  color: ${Colors.GRAY_DARK_30};
  display: flex;
  font-weight: bold;
  height: 24px;
  justify-content: center;
  padding-top: 2px;
  width: 24px;
`;

const CartText = styled.div`
  margin: 0 ${Spacing.QUARTER};
`;

export const CartButton: React.FC<CartButtonProps> = ({ displayNum }) => (
  <StyledCartButton color={displayNum === 0 && ButtonColors.GRAY}>
    <CartIcon width='24px' height='24px' color={Colors.WHITE} />
    <CartText>Cart</CartText>
    <ShefCartsNumber>{displayNum}</ShefCartsNumber>
  </StyledCartButton>
);
